import { DataLogRq, SourcePage } from '@domain/rq/DataLog';
import { EmploymentStatusType, EmploymentType } from '@domain/constant/profile/CareerType';
import DateFormat from '@utils/date/format';

export class ProfileCareerSaveVO {
  sn: number | null;
  companySn: number | null;
  companyName: string;
  employmentStatus: EmploymentStatusType | null; // 재직 상태
  startDate?: string | null;
  endDate?: string | null;
  jobGroupCode: number | null; // 직군 코드
  jobTitleCode: number | null; // 직무 코드
  employmentType: EmploymentType | null; // 계약 형태
  performance: string | null; // 주요 성과
  role: string | null;
  verified: boolean | null;

  constructor(dto: ProfileCareerSaveVO) {
    this.sn = dto.sn;
    this.companySn = dto.companySn;
    this.companyName = dto.companyName;
    this.employmentStatus = dto.employmentStatus;
    this.startDate = DateFormat.getDateFormatString(dto.startDate, 'yyyy-MM');
    this.endDate = DateFormat.getDateFormatString(dto.endDate, 'yyyy-MM');
    this.jobGroupCode = dto.jobGroupCode;
    this.jobTitleCode = dto.jobTitleCode;
    this.employmentType = dto.employmentType;
    this.performance = dto.performance;
    this.role = dto.role;
    this.verified = dto.verified;
  }
}

export default class ProfileCareerSaveRq {
  profileCareers: ProfileCareerSaveVO[];
  sourcePage?: SourcePage;

  constructor(rq: ProfileCareerSaveDto) {
    this.profileCareers = rq.profileCareers.map((dto) => new ProfileCareerSaveVO(dto));
    this.sourcePage = rq.sourcePage;
  }
}

export interface ProfileCareerSaveDto extends DataLogRq {
  profileCareers: ProfileCareerSaveVO[];
}
